<div mat-dialog-title>{{title}}</div>
<div mat-dialog-content>{{message}}</div>

<div mat-dialog-actions>
    <button mat-stroked-button type="button" (click)="close()">
        {{'global.close'|translate}}
    </button>
</div>